module.exports = __webpack_public_path__ + "static/media/enterprise.687b0109.svg";